module.exports = __webpack_public_path__ + "static/icon_buyStep5-6ceb5daa5744e5a590a87148fea9a53a.png";